const createSeoConfig = ({
  title,
  description,
  images,
  ...rest
}) => ({
  title,
  titleTemplate: "Rather | %s",
  description,
  canonical: "https://rather.tv",
  openGraph: {
    url: "https://rather.tv",
    title,
    description,
    images,
    site_name: "Rather",
  },
  ...rest,
});

export default createSeoConfig;
